import { lazy } from '../../../shared/deployment';

// eslint-disable-next-line import/prefer-default-export
export const JMTSubmission = lazy(() => import('./JMTSubmission'));
